import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import { FormInputDatePicker } from "../../../ReactHookForm/FormComponents";
import {UserTypes} from "root/DataFunctions/Constants";
import DropdownUsers from "root/ReactHookForm/ui/DropdownUsers";

const HookSubFormSocialWorker = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateCarer = (val) =>
    {
        if (val === null)
        {
            return "Please Select a social Worker.";
        }
    }

    return (
        <FieldsetContainer title='Social Worker' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <label className='col-form-label'>Select a Social Worker (Use the filter to narrow down the list)</label>
                    <DropdownUsers name={sectionName + '.social_worker_id'} user_type={UserTypes.SOCIAL_WORKER} control={control} rules={{validate: validateCarer}}
                                                      placeHolder='Pick a Social Worker' readOnly={readOnly} isSearchable={true}/>
                    {formErrors[sectionName]?.social_worker_id?.type === 'validate' && <ErrorDiv>Please select a social worker</ErrorDiv>}

                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='Date Started' sectionName={sectionName}
                                         name={'date_sw_started'}
                                         control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>

        </FieldsetContainer>
    )
}


export default HookSubFormSocialWorker;
